export class BackendModel {
    id:number|undefined = undefined
    name:string = ''
    vendor:string = ''

    constructor(b?:Partial<BackendModel>) {
        Object.assign(this, b)
    }
}
